export default __webpack_public_path__ + "static/media/ethasset.51938245.png";